// modal/detail/ui/PermissionToggleRow.jsx
import React from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Icon from '@mui/material/Icon';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useTheme as useMuiTheme } from '@mui/material/styles';

import { GreenSwitch } from './GreenSwitch';

export function PermissionToggleRow({ label, enabled, onToggle }) {
  const theme = useMuiTheme();

  return (
    <MDBox
      sx={{
        p: 1.15,
        borderRadius: '16px',
        border: `1px solid ${theme.palette.divider}`,
        background: theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.2,
      }}
    >
      <MDBox display="flex" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
        <MDBox
          sx={{
            width: 30,
            height: 30,
            borderRadius: '12px',
            display: 'grid',
            placeItems: 'center',
            background: enabled ? 'rgba(0,150,136,.10)' : 'rgba(0,0,0,.04)',
            border: `1px solid ${enabled ? 'rgba(0,150,136,.22)' : theme.palette.divider}`,
          }}
        >
          <Icon sx={{ fontSize: 18, color: enabled ? '#009688' : theme.palette.text.disabled }}>
            {enabled ? 'check' : 'close'}
          </Icon>
        </MDBox>

        <MDTypography
          variant="button"
          fontWeight="medium"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {label}
        </MDTypography>
      </MDBox>

      <FormControlLabel
        sx={{ m: 0 }}
        control={<GreenSwitch checked={!!enabled} onChange={(e) => onToggle?.(e.target.checked)} />}
        label=""
      />
    </MDBox>
  );
}
